

export enum eJSON_BRANCH_TYPE
{
  eBRANCH_NONE                       = 0,    // Do not alter order or numbers.
  eBRANCH_TYPE_MATH_VALVE_DETAIL     = 1,    // These are used in the WEBAPP as well
  eBRANCH_TYPE_FURTI_VALVE_DETAIL    = 2,
  eBRANCH_TYPE_OUTSIDE_OVERVIEW      = 3,
  eBRANCH_TYPE_SINGLE_VALVE_SUMMARY  = 4,
  eBRANCH_TYPE_ZONE_OVERVIEW         = 5,
  eBRANCH_TYPE_DAYSUPPLY_OVERVIEW    = 6,
  eBRANCH_TYPE_UNIT_OVERVIEW         = 7,
  eBRANCH_TYPE_AFARM_OVERVIEW        = 8

}
